import { TranslatedCopy } from '../intl/TranslatedCopy';

export const AVAILABILITY_COLUMNS_BY_SALES_ORG = ['2000', '9600', '9700', '9800', '9810', '8700', '7000'];

export const AVAILABILITY_GROUP_SIZE = 20;

export const VALUE_NA = 'N/A';
export const NO_IMAGE = 'NO IMAGE';

export const FILTER_CATALOGS = 'catalogs';
export const FILTER_COLOR = 'color';
export const FILTER_DIMENSIONS = 'dimensions';
export const FILTER_SEGMENT = 'segment';
export const FILTER_SILHOUETTE = 'silhouette';
export const FILTER_SIZE = 'size';
export const FILTER_SPORT = 'sport';

export const GRIDWALL_PRODUCT_LOAD_QTY = 12;
export const GRIDWALL_PRODUCT_SEARCH_LOAD_QTY = 72;
export const GRIDWALL_MIN_PRICE = 0;
export const GRIDWALL_MAX_PRICE = 100000;

export const PAYMENT_COMP = 'COMP';
export const PAYMENT_COMP_CASH = 'COMP-CASH';
export const PAYMENT_DS_COMP = 'DS_COMP';
export const PAYMENT_BILLABLE = 'BILLABLE';
export const PAYMENT_DS_BILLABLE = 'DS_BILLABLE';
export const PAYMENT_COMP_AND_BILLABLE = `${PAYMENT_COMP}_${PAYMENT_BILLABLE}`;
export const PAYMENT_DS_COMP_AND_BILLABLE = `DS_${PAYMENT_COMP_AND_BILLABLE}`;
export const PAYMENT_UNIT = 'UNIT';
export const PAYMENT_COMP_UNIT = 'COMP-UNIT';
export const PAYMENT_FREE = 'FREE';
export const NOT_AVAILABLE_PAYMENT = 'NA';

export const PAYMENT_METHOD_OPTIONS = [PAYMENT_BILLABLE, PAYMENT_COMP, PAYMENT_UNIT, PAYMENT_FREE];
export const ORDER_PAYMENT_METHOD_OPTIONS = [
  PAYMENT_COMP_CASH,
  PAYMENT_COMP_UNIT,
  PAYMENT_BILLABLE,
  PAYMENT_FREE,
  NOT_AVAILABLE_PAYMENT
];

export const PRODUCT_ATTRIBUTE_SILHOUETTE = 'SIL';
export const PRODUCT_SEARCH_MAX = 100;

export const PDP_QUANTITY_MAXLEN = 4;

export const CUSTOM_DATE_RANGE = 'custom';
export const DEFAULT_DATE_RANGE = '24 months';
export const RETURN_CODE_UNSUBMITTED = 'UNSUBMITTED';
export const RETURN_CODE_SUBMITTED = 'SUBMITTED';

export const IMG_TYPE_PRIMARY = 'PRIMARY';
export const IMG_TYPE_SECONDARY = 'SECONDARY';
export const IMG_TYPE_THUMBNAIL = 'THUMBNAIL';
export const IMG_TYPE_GRIDWALL = 'GRIDWALL';
export const IMG_TYPE_LINE_ART = 'LINE_ART';

export const APPAREL_SUBTYPES = ['TOP', 'BOTTOM', 'HEADWEAR', 'APPAREL-OTHER'];
export const FOOTWEAR_SUBTYPES = ['BOOT', 'SANDAL', 'SHOE', 'FOOTWEAR-OTHER'];
export const EQUIPMENT_SUBTYPES = ['BAG', 'SOCK', 'GLOVE', 'BALL', 'EQUIPMENT-OTHER'];

export const countryMap = new Map([
  ['US', 'USA'],
  ['CA', 'CAN'],
  ['UK', 'EU'],
  ['EU', 'EU'],
  ['FR', 'EU'],
  ['DE', 'EU'],
  ['FR', 'EU'],
  ['IT', 'EU'],
  ['PT', 'EU'],
  ['SP', 'EU'],
  ['TR', 'EU']
]);
export const regionToLanguageMap = new Map([
  ['USA', ['EN']],
  ['CANADA', ['EN', 'FR']],
  ['EURO', ['EN', 'DE', 'FR', 'IT', 'PT', 'SP', 'TR']],
  ['CHINA', ['ZH', 'ZF']],
  ['TAIWAN', ['ZH', 'ZF']],
  ['HONG KONG', ['ZH', 'ZF']],
  ['AUSTRALIA', ['EN']],
  ['NEW ZEALAND', ['EN']],
  ['JAPAN', ['EN', 'JA']],
  ['REP OF KOREA', ['EN', 'KO']]
]);
export const supportedLanguages = ['CN', 'DE', 'EN', 'ES', 'FR', 'IT', 'PT', 'TR'];
export const languageMap = new Map([
  ['de_de', 'DE'],
  ['en_us', 'EN'],
  ['fr_fr', 'FR'],
  ['it_it', 'IT'],
  ['pt_pt', 'PT'],
  ['sp_sp', 'SP'],
  ['tr_tr', 'TR']
]);
export const paymentMethodsMap = new Map([
  [PAYMENT_BILLABLE, 'BILLABLE'],
  [PAYMENT_COMP, 'COMP-CASH'],
  [PAYMENT_UNIT, 'COMP-UNIT'],
  [PAYMENT_FREE, 'FREE']
]);
export const productDivisionMap = new Map([
  ['APRL', 'apparel'],
  ['FTWR', 'footwear'],
  ['EQMT', 'equipment_&_accessories'],
  ['MENS', 'mens'],
  ['YOUNG MEN', 'mens'],
  ['WOMENS', 'womens'],
  ['YOUNG WOMEN', 'womens'],
  ['BOYS PRE SCHOOL', 'boys'],
  ['BOYS GRADE SCHL', 'boys'],
  ['BOYS TODDLER', 'boys'],
  ['BOYS', 'boys'],
  ['GIRL PRE SCHOOL', 'girls'],
  ['GIRL GRADE SCHL', 'girls'],
  ['GIRLS TODDLER', 'girls'],
  ['GIRLS', 'girls'],
  ['GRD SCHOOL UNSX', 'unisex'],
  ['YOUTH UNISEX', 'unisex'],
  ['ADULT UNISEX', 'unisex'],
  ['UNISEX', 'unisex']
]);
export const productDivisionMapWithAge = new Map([
  ['APRL', 'apparel'],
  ['FTWR', 'footwear'],
  ['EQMT', 'equipment_&_accessories'],
  ['MENS', 'adultMens'],
  ['YOUNG MEN', 'adultMens'],
  ['WOMENS', 'adultWomens'],
  ['YOUNG WOMEN', 'adultWomens'],
  ['BOYS PRE SCHOOL', 'youthBoys'],
  ['BOYS GRADE SCHL', 'youthBoys'],
  ['BOYS TODDLER', 'youthBoys'],
  ['BOYS', 'youthBoys'],
  ['GIRL PRE SCHOOL', 'youthGirls'],
  ['GIRL GRADE SCHL', 'youthGirls'],
  ['GIRLS TODDLER', 'youthGirls'],
  ['GIRLS', 'youthGirls'],
  ['GRD SCHOOL UNSX', 'youthUnisex'],
  ['YOUTH UNISEX', 'youthUnisex'],
  ['ADULT UNISEX', 'adultUnisex'],
  ['UNISEX', 'adultUnisex']
]);
export const SHOP_URL = '/shop';
export const DEPT_SELECT_URL = '/shop/department-select';
export const ORDER_TYPE_ATONCE = 'atonce';
export const ORDER_TYPE_ATONCE_ALT = 'atonce-alt';
export const ORDER_TYPE_FUTURES = 'futures';
export const ORDER_TYPE_FORECAST = 'forecast';
export const CONTRACT_PERIOD_CURRENT = 'current';
export const CONTRACT_PERIOD_NEXT = 'next';
export const paymentMethodsSelect = [
  { label: new TranslatedCopy({ id: 'global.comp' }).toString(), value: PAYMENT_COMP },
  { label: new TranslatedCopy({ id: 'global.billable' }).toString(), value: PAYMENT_BILLABLE },
  {
    label: new TranslatedCopy({ id: 'global.unitAllotment' }).toString(),
    value: PAYMENT_UNIT
  }
];

export const LABEL_SELECT_ALL = new TranslatedCopy({ id: 'global.all' }).toString();

export const DEFAULT_SHOP_PRODUCT_STRUCTURE = {
  id: '',
  directShip: false,
  returnable: false,
  season: '',
  region: '',
  color: '',
  segment: '',
  dimensions: '',
  division: '',
  styleGenderAge: '',
  category: '',
  colorName: '',
  deliveryUnitOfMeasure: '',
  deliveryUnit: 0,
  prePackIndicator: false,
  prePackCode: 0,
  productRegionPromoIndicator: '',
  sport: '',
  silhouette: {
    description: '',
    code: ''
  },
  silhouetteType: {
    description: '',
    code: ''
  },
  productCode: '',
  team: {},
  copy: {
    name: '',
    language: '',
    description: ''
  },
  bom: {
    colors: {
      primary: ''
    }
  },
  offerDates: {
    endFuture: '',
    endProduct: '',
    firstProduct: ''
  },
  sizes: [],
  prices: [
    {
      retail: 0,
      wholesale: 0,
      currency: '',
      priceListType: ''
    }
  ],
  images: []
};
